import React, { Fragment, useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router'
import { setFamiliaSeleccionada } from '../../actions/familias'
import { anadirFiltro, limpiarFiltros } from '../../actions/filtros'
import { getMigasArticulo, limpiarMigas } from '../../actions/migas'
import { dynamicSort } from '../../helpers/funciones'

const Migas = props => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const migas = useSelector(state => state.migas.migas)
  const auth = useSelector(state => state.auth)

  const itemsToShow = useMemo(() => (migas ? migas.reverse() : []))

  let { id_articulo } = props
  let hash = auth.hash

  useEffect(() => {
    return () => dispatch(limpiarMigas())
  }, [])

  useEffect(() => {
    dispatch(getMigasArticulo(id_articulo, hash != null ? hash : ''))
  }, [id_articulo, hash])

  const onClick = e => {
    e.preventDefault()
    let _estadistico = e.target.dataset.estadistico
    let _familia = e.target.dataset.codigo
    let _nombre = e.target.dataset.familia

    dispatch(limpiarFiltros())

    dispatch(
      anadirFiltro({
        estadistico: _estadistico,
        familia: _familia,
        nombre: _nombre,
        tipo: 'estad',
      }),
    )

    dispatch(setFamiliaSeleccionada(_estadistico, _familia, _nombre))
    navigate('/articulos')
  }

  return (
    <Fragment>
      <div className='tt-breadcrumb'>
        <div className='container'>
          <ul>
            {itemsToShow ? (
              itemsToShow?.map((miga, idx) => (
                <li key={idx}>
                  <a
                    href='#'
                    onClick={onClick}
                    data-codigo={miga.familia}
                    data-estadistico={miga.estadistico}
                    data-familia={miga.descripcion}>
                    {miga.descripcion}
                  </a>
                </li>
              ))
            ) : (
              <></>
            )}
          </ul>
        </div>
      </div>
    </Fragment>
  )
}

export default Migas
